module.exports = __webpack_public_path__ + "img/projects.5ed97555.png";